<template>
  <div class="side-bar__panel side-bar__panel--menu">
    <menu-entry @click.native="exportMarkdown">
      <icon-download slot="icon"></icon-download>
      <div>导出Markdown类型文件</div>
      <span>导出为.md后缀的文件</span>
    </menu-entry>
    <menu-entry @click.native="exportHtml">
      <icon-download slot="icon"></icon-download>
      <div>导出HTML类型文件</div>
      <span>根据模板生成一个网页文件</span>
    </menu-entry>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MenuEntry from './common/MenuEntry';
import exportSvc from '../../services/exportSvc';
import store from '../../store';

export default {
  components: {
    MenuEntry,
  },
  computed: mapGetters(['isSponsor']),
  methods: {
    exportMarkdown() {
      const currentFile = store.getters['file/current'];
      return exportSvc.exportToDisk(currentFile.id, 'md')
        .catch(() => { /* Cancel */ });
    },
    exportHtml() {
      return store.dispatch('modal/open', 'htmlExport')
        .catch(() => { /* Cancel */ });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/menus/ExportMenu.vue